import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureCardGrid from "../components/FeatureCardGrid";
import { LayoutGrid, Boxes, Layers, Filter, Move, Bookmark } from "lucide-react";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { FEATURE_SOFTWARE_LD } from "../data/featurePages";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/fonctionnalites/dashboard-trading";

export default function FeatureDashboardPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.features.dashboard;
  return (
    <MarketingPageLayout>
      <SeoHelmet path={PATH} title={m.title} description={m.description} jsonLd={[FEATURE_SOFTWARE_LD]} />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureCardGrid
        bullets={c.bullets}
        image="/images/features/dashboard.png"
        imageAlt={c.h1}
        icons={[LayoutGrid, Boxes, Layers, Filter, Move, Bookmark]}
      />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/fonctionnalites/prop-firm-manager", label: t.marketing.nav.megaFeatures[1].label },
          { to: "/fonctionnalites/analytics-trading", label: t.marketing.nav.megaFeatures[2].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
